<template>
    <div class="record">
        <div
            class="record-area"
            ref="recordScroll"
        >
            <van-tabs
                v-model="active"
                color="#4DB3FF"
                @click="handleTopTabs"
            >
                <van-tab title="数据报表">
                    <div class="record-content">
                        <div class="report-show">
                            <div class="head">
                                <div class="title">总报表</div>

                                <div class="select-date">
                                    <div
                                        class="select-wrapper"
                                        @click="selectDateShow"
                                    >
                                        <span class="select" style="border: none; color: #007aff">{{currentMonth}}</span>
                                    </div>
                                </div>
                                <div class="select-date">
                                    <div
                                        class="select-wrapper"
                                        @click="selectCanalShow"
                                    >
                                        <span class="select">{{canalName}}</span>
                                        <span class="icon-wrapper">
                                          <i class="iconfont select-icon">&#xe61c;</i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="table-wrapper table-total-wrapper">
                            <div
                                class="hosp-name"
                                v-show="totalMonthData.length > 1"
                            >
                                <p class="tr">
                                    <span class="td">项目</span>
                                </p>
                                <p
                                    class="tr"
                                    v-for="(item, index) in totalMonthData"
                                    :key="index"
                                >
                                    <span class="td">{{item.hos_name}}</span>
                                </p>
                            </div>
                            <div
                                class="table-content"
                                :class="{active: totalMonthData.length > 1}"
                                ref="totalReport"
                            >
                                <div class="total-table">
                                    <div class="thead">
                                        <p class="tr">
                                            <span class="th">消费</span>
                                            <span class="th">到诊</span>
                                            <span class="th">到诊进度</span>
                                            <span class="th">到诊成本</span>
                                            <span class="th">对话</span>
                                            <span class="th">对话成本</span>
                                            <span class="th">确诊对话</span>
                                            <span class="th">确诊对话成本</span>
                                            <span class="th">到诊转化率</span>
                                            <span class="th">完成进度</span>
                                        </p>
                                    </div>
                                    <div class="tbody">
                                        <p
                                            class="tr"
                                            v-for="(item, index) in totalMonthData"
                                            :key="index"
                                        >
                                            <span class="td">{{item.cost_price}}万</span>
                                            <span class="td">{{item.in_count}}</span>
                                            <span class="td">{{item.progress_arrive}}</span>
                                            <span class="td">{{item.in_base}}</span>
                                            <span class="td">{{item.dialog_count}}</span>
                                            <span class="td">{{item.dialog_cost}}</span>
                                            <span class="td">{{item.sure_count}}</span>
                                            <span class="td">{{item.sure_base}}</span>
                                            <span class="td">{{item.conversion}}</span>
                                            <span class="td">{{item.progress}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="report-show">
                            <div class="head">
                                <div class="title">日报表</div>
                                <div
                                    class="select-day"
                                    @click="selectDayShow"
                                >
                                  <span class="icon-wrapper">
                                    <i class="iconfont select-icon">&#xe60e;</i>
                                  </span>
                                    <span class="select">{{dayDate}}</span>
                                </div>
                                <div class="select-date">
                                    <div
                                            class="select-wrapper"
                                            @click="daySelectCanalShow"
                                    >
                                        <span class="select">{{dayCanalName}}</span>
                                        <span class="icon-wrapper">
                                          <i class="iconfont select-icon">&#xe61c;</i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="table-wrapper table-day-wrapper">
                                <div
                                    class="hosp-name"
                                    v-show="dayDateData.length > 1"
                                >
                                    <p class="tr">
                                        <span class="td">项目</span>
                                    </p>
                                    <p
                                        class="tr"
                                        v-for="(item, index) in dayDateData"
                                        :key="index"
                                    >
                                        <span class="td">{{item.hos_name}}</span>
                                    </p>
                                </div>
                                <div
                                    class="table-content"
                                    :class="{active: dayDateData.length > 1}"
                                >
                                    <div class="total-table day-date-table">
                                        <div class="thead">
                                            <p class="tr">
                                                <span class="th">消费</span>
                                                <span class="th">到诊</span>
                                                <span class="th">对话</span>
                                                <span class="th">确诊对话</span>
                                            </p>
                                        </div>
                                        <div class="tbody">
                                            <p
                                                class="tr"
                                                v-for="(item, index) in dayDateData"
                                                :key="index"
                                            >
                                                <span class="td">{{item.cost_price}}万</span>
                                                <span class="td">{{item.in_count}}</span>
                                                <span class="td">{{item.dialog_count}}</span>
                                                <span class="td">{{item.sure_count}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="数据同比">
                    <van-row class="view-report">
                        <van-col span="24">
                            <div class="header-select">
                                <div class="select-wrapper" @click="selectShow">
                                    <span class="select">
                                        {{ cuuentHospital }}
                                    </span>
                                    <span class="icon-wrapper">
                                        <i class="iconfont select-icon">&#xe61c;</i>
                                    </span>
                                </div>
                                <div class="select-date">
                                    <div
                                        class="select-wrapper"
                                        @click="selectDataCanalShow"
                                    >
                                        <span class="select">{{ dataCanalName }}</span>
                                        <span class="icon-wrapper">
                                          <i class="iconfont select-icon">&#xe61c;</i>
                                        </span>
                                    </div>
                                </div>
                                <div class="select-date">
                                    <div
                                        class="select-wrapper"
                                        @click="selectDateShow"
                                    >
                                        <span class="select" style="border: none; color: #007aff">{{ dataCurrentMonth }}</span>
                                    </div>
                                </div>
                            </div>
                        </van-col>
                        <div class="table-wrapper table-total-wrapper">
                                <div class="hosp-name hosp-names" v-show="dataTotalContrast.length > 0">
                                    <p class="tr">
                                        <span class="td">时间</span>
                                    </p>
                                    <!-- <p
                                        class="tr"
                                        v-for="(item, index) in dataTotalContrast"
                                        :key="index"
                                    >
                                        <span class="td">{{item.year}}</span>
                                    </p> -->
                                    
                                    <p class="tr">
                                        <span class="th">消费</span>
                                    </p>
                                    <p class="tr">
                                        <span class="th">到诊</span>
                                    </p>
                                    <p class="tr">
                                        <span class="th">到诊成本</span>
                                    </p>
                                    <p class="tr">
                                        <span class="th">对话</span>
                                    </p>
                                    <p class="tr">
                                        <span class="th">对话成本</span>
                                    </p>
                                    <p class="tr">
                                        <span class="th">确诊对话</span>
                                    </p>
                                    <p class="tr">
                                        <span class="th">确诊对话成本</span>
                                    </p>
                                    <p class="tr">
                                        <span class="th">到诊转化率</span>
                                    </p>
                                </div>
                                <div class="table-content table-contents" :class="{active: dataTotalContrast.length > 0}" ref="dataTotalReport">
                                    <div class="total-table" :style="style">
                                        <!-- <div class="thead">
                                            <p class="tr">
                                                <span class="th">消费</span>
                                                <span class="th">到诊</span>
                                                <span class="th">到诊成本</span>
                                                <span class="th">对话</span>
                                                <span class="th">对话成本</span>
                                                <span class="th">确诊对话</span>
                                                <span class="th">确诊对话成本</span>
                                                <span class="th">到诊转化率</span>
                                            </p>
                                        </div> -->
                                        <div class="tbody">
                                            <!-- <p
                                                class="tr"
                                                v-for="(item, index) in dataTotalContrast"
                                                :key="index"
                                            >
                                                <span class="td">{{item.cost_price}}万</span>
                                                <span class="td">{{item.in_count}}</span>
                                                <span class="td">{{item.in_base}}</span>
                                                <span class="td">{{item.dialog_count}}</span>
                                                <span class="td">{{item.dialog_cost}}</span>
                                                <span class="td">{{item.sure_count}}</span>
                                                <span class="td">{{item.sure_base}}</span>
                                                <span class="td">{{item.conversion}}</span>
                                            </p> -->
                                            <span v-for="(item, index) in dataTotalContrast" :key="index">
                                                <p class="tr trs"><span class="td">{{item.year}}</span></p>
                                                <p class="tr"><span class="td">{{item.cost_price}}万</span></p>
                                                <p class="tr"><span class="td">{{item.in_count}}</span></p>
                                                <p class="tr"><span class="td">{{item.in_base}}</span></p>
                                                <p class="tr"><span class="td">{{item.dialog_count}}</span></p>
                                                <p class="tr"><span class="td">{{item.dialog_cost}}</span></p>
                                                <p class="tr"><span class="td">{{item.sure_count}}</span></p>
                                                <p class="tr"><span class="td">{{item.sure_base}}</span></p>
                                                <p class="tr"><span class="td">{{item.conversion}}</span></p>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </van-row>
                </van-tab>
                <van-tab title="任务制定">
                    <van-row class="view-report">
                        <van-col span="24">
                            <div class="header-select">
                                <div class="select-wrapper" @click="selectShow">
                                    <span class="select">
                                        {{ cuuentHospital }}
                                    </span>
                                    <span class="icon-wrapper">
                                        <i class="iconfont select-icon">&#xe61c;</i>
                                    </span>
                                </div>
                                <div class="select-date">
                                    <div
                                            class="select-wrapper"
                                            @click="selectDataCanalShow"
                                    >
                                        <span class="select">{{ dataCanalName }}</span>
                                        <span class="icon-wrapper">
                                          <i class="iconfont select-icon">&#xe61c;</i>
                                        </span>
                                    </div>
                                </div>
                                <div class="select-date">
                                    <div
                                            class="select-wrapper"
                                            @click="selectDateShowPlan"
                                    >
                                        <span class="select" style="border: none; color: #007aff">{{ dataCurrentMonthPlan }}</span>
                                    </div>
                                </div>
                            </div>
                        </van-col>
                        <div class="table-wrapper table-total-wrapper">
                            <div class="hosp-name hosp-names" v-show="dataTotalContrastPlan.length > 0">
                                <p class="tr">
                                    <span class="td">年份</span>
                                </p>
                                <p class="tr">
                                    <span class="th">月份</span>
                                </p>
                                <p class="tr">
                                    <span class="th">消费</span>
                                </p>
                                <p class="tr">
                                    <span class="th">到诊</span>
                                </p>
                                <p class="tr">
                                    <span class="th">到诊成本</span>
                                </p>
                                <p class="tr">
                                    <span class="th">对话</span>
                                </p>
                                <p class="tr">
                                    <span class="th">对话成本</span>
                                </p>
                                <p class="tr">
                                    <span class="th">确诊对话</span>
                                </p>
                                <p class="tr">
                                    <span class="th">确诊对话成本</span>
                                </p>
                                <p class="tr">
                                    <span class="th">对话到诊率</span>
                                </p>
                            </div>
                            <div class="table-content table-contents table-contents2" :class="{active: dataTotalContrastPlan.length > 0}" ref="dataTotalReport">
                                <div class="total-table" :style="style">
                                    <div class="tbody tbody2">
                                        <span v-for="(item, index) in dataTotalContrastPlan" :key="index">
                                                <p class="tr trs"><span class="td">{{item.year}}</span></p>
                                                <p class="tr"><span class="td">{{item.month}}月</span></p>
                                                <p class="tr"><span class="td">{{item.cost_price}}万 <span v-if="item.cost_rate"><span v-if="item.cost_rate>0" style="color: red;font-size: 12px;float: right;margin-right: 5px">{{item.cost_rate}}%</span><span v-if="item.cost_rate<0" style="color: green;font-size: 12px;float: right;margin-right: 5px">{{item.cost_rate}}%</span></span></span></p>
                                                <p class="tr"><span class="td">{{item.in_count}}  <span v-if="item.in_count_rate"><span v-if="item.in_count_rate>0" style="color: red;font-size: 12px;float: right;margin-right: 5px">{{item.in_count_rate}}%</span><span v-if="item.in_count_rate<0" style="color: green;font-size: 12px;float: right;margin-right: 5px">{{item.in_count_rate}}%</span></span></span></p>
                                                <p class="tr"><span class="td">{{item.in_base}}  <span v-if="item.in_base_rate"><span v-if="item.in_base_rate>0" style="color: red;font-size: 12px;float: right;margin-right: 5px">{{item.in_base_rate}}%</span><span v-if="item.in_base_rate<0" style="color: green;font-size: 12px;float: right;margin-right: 5px">{{item.in_base_rate}}%</span></span></span></p>
                                                <p class="tr"><span class="td">{{item.dialog_count}}  <span v-if="item.dialog_count_rate"><span v-if="item.dialog_count_rate>0" style="color: red;font-size: 12px;float: right;margin-right: 5px">{{item.dialog_count_rate}}%</span><span v-if="item.dialog_count_rate<0" style="color: green;font-size: 12px;float: right;margin-right: 5px">{{item.dialog_count_rate}}%</span></span></span></p>
                                                <p class="tr"><span class="td">{{item.dialog_cost}}</span></p>
                                                <p class="tr"><span class="td">{{item.sure_count}}  <span v-if="item.sure_count_rate"><span v-if="item.sure_count_rate>0" style="color: red;font-size: 12px;float: right;margin-right: 5px">{{item.sure_count_rate}}%</span><span v-if="item.sure_count_rate<0" style="color: green;font-size: 12px;float: right;margin-right: 5px">{{item.sure_count_rate}}%</span></span></span></p>
                                                <p class="tr"><span class="td">{{item.sure_base}}</span></p>
                                                <p class="tr"><span class="td">{{item.conversion}}</span></p>
                                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-row>
                </van-tab>

            </van-tabs>

        </div>
        <div  class="mask" v-if="selectDatePicker">
            <div class="mask-data">
                <div class="action-style">
                    <span style="margin-right: 40px;" @click="cancleFail">取消</span>
                    <span style="color: #0066ff;margin-left: 40px" @click="cancleOk">确定</span>
                </div>
                <div v-if="isView">
                    <inlineCalendar
                        mode="during"
                        :day-click="dataDayClick"
                        :restrict-current-month="false"
                        @change="onChangeData"
                        @switch="handelSwitchData" />
                </div>
                <div v-else>
                    <inlineCalendar
                        mode="during"
                        :day-click="dayClick"
                        :restrict-current-month="false"
                        @change="onChange"
                        @switch="handelSwitch" />
                </div>
            </div>
        </div>
        <!-- 渠道筛选-->
        <awesome-picker
            ref="selectPickerCanal"
            :data="pickerCanal.data"
            :textTitle="pickerCanal.textTitle"
            :anchor="pickerCanal.anchor"
            @confirm="handleSelectCanal"
        ></awesome-picker>

        <!--    每日数据渠道筛选    -->
        <awesome-picker
                ref="daySelectPickerCanal"
                :data="dayPickerCanal.data"
                :textTitle="dayPickerCanal.textTitle"
                :anchor="dayPickerCanal.anchor"
                @confirm="dayHandleSelectCanal"
        ></awesome-picker>
<!--            数据同比渠道筛选-->
        <awesome-picker
            ref="selectDataPickerCanal"
            :data="pickerDataCanal.data"
            :textTitle="pickerDataCanal.textTitle"
            :anchor="pickerDataCanal.anchor"
            @confirm="handleDataSelectCanal"
        >
        </awesome-picker>
        <!-- 天Picker -->
        <awesome-picker
            ref="selectDayPicker"
            :type="DayPicker.type"
            :textTitle="DayPicker.textTitle"
            :anchor="DayPicker.anchor"
            @confirm="handleSelectDay"
        ></awesome-picker>
        <!-- 开始日期选择 -->
        <awesome-picker
            ref="startDate"
            :data="startDate.data"
            :textTitle="startDate.textTitle"
            :anchor="startDate.anchor"
            @confirm="handleStartDate"
        ></awesome-picker>
<!--        项目选择-->
        <awesome-picker
            ref="selectPicker"
            :data="picker.data"
            :textTitle="picker.textTitle"
            :anchor="picker.anchor"
            @confirm="handleSelectHospital"
        >
        </awesome-picker>
        <v-footer></v-footer>
    </div>
</template>

<script>
    import axios from "axios";
    import BScroll from "better-scroll";
    import dayjs from 'dayjs'
    import {
        fallback,
        getDay,
        defPickerDate,
        defPickerAnchor
    } from "@/assets/js/_mm.js";
    import VFooter from "@/pages/components/v-footer";
    export default {
        name: "Home",
        data() {
            return {
                style: {},
                active: 0,
                project: "",
                dataSele: [],
                dataSeleReport: [],
                selectDatePicker: false,
                switchData: '',
                switchDataReport: '',
                projectList: [],
                channelList: [],
                picker: {
                    data: [],
                    textTitle: '医院选择',
                    anchor: []
                },
                cuuentHospital: '',
                isView: false,
                startDate: new Date(),
                datePicker: {
                    data: this.defPickerDate(),
                    textTitle: "月份选择",
                    anchor: this.defPickerAnchor()
                },
                DayPicker: {
                    type: "date",
                    textTitle: "日期选择",
                    anchor: [],
                },
                startDate: {
                    data: this.defPickerDate(),
                    textTitle: "开始日期选择",
                    anchor: this.defPickerAnchor()
                },
                // 渠道筛选
                pickerCanal: {
                    data: [],
                    textTitle: '渠道选择',
                    anchor: []
                },
                dayPickerCanal: {
                    data: [],
                    textTitle: '渠道选择',
                    anchor: []
                },
                pickerDataCanal: {
                    data: [],
                    textTitle: '渠道选择',
                    anchor: []
                },
                nowYear: dayjs().format('YYYY'),
                dataCurrentMonth: (() => {
                    return (
                        (new Date().getMonth() + 1) + "-01"+'~'+(new Date().getMonth() + 1) + '-' + new Date().getDate()
                    );
                })(), //数据显示时间
                dataCurrentMonthPlan: (() => {
                    return (
                        (new Date().getMonth() + 1) + "月"
                    );
                })(), //任务制定数据显示时间
                channelListId: '',
                dayChannelListId: '',
                dataChannelListId: '',
                canalName: '全部',
                dayCanalName: '全部',
                dataCanalName: '全部',
                // dataTotalContrast: [],
                dataTotalContrast: [
                    // { year: "2020", total_in_count: "405", cost_price: 949, in_count: 12, dialog_count: 216, sure_count: 49, in_base: 7914.77, dialog_base: 439.71, sure_base: 1938.31},
                    // { year: 2019, total_in_count: "420", cost_price: 1669, in_count: 412, dialog_count: 3661, sure_count: 904, in_base: 4036.86, dialog_base: 454.3, sure_base: 1839.81},
                    // { year: 2018, total_in_count: "419", cost_price: 10, in_count: 419, dialog_count: 1532, sure_count: 0, in_base: 3477.57, dialog_base: 951.11, sure_base: 0},
                    // { year: 2017, total_in_count: "347", cost_price: 9200, in_count: 347, dialog_count: 1298, sure_count: 0, in_base: 2663.98, dialog_base: 712.17, sure_base: 0}
                ],
                dataTotalContrastPlan:[],
                startDateValue: (() => {
                    let year = new Date().getFullYear();
                    let month = new Date().getMonth() + 1;
                    let diff = month - 6;
                    if (diff < 0) {
                        year -= 1;
                        month = diff + 12;
                    } else {
                        month = diff;
                    }
                    return `${year}-${month}`;

                })(),
                currentMonth: (() => {
                    return (
                        new Date().getFullYear() + "年" + (new Date().getMonth() + 1) + "月"
                    );
                })(),
                currentYear: (() => {
                    return new Date().getFullYear();
                })(),
                dayDate: (() => {
                    let keep = getDay(-1, "-").split("-");
                    return keep[1] + "月" + keep[2] + "日";
                })(),
                defDate: (() => {
                    return (
                        new Date().getFullYear() + "年" + (new Date().getMonth() + 1) + "月"
                    );
                })(),
                totalMonthData: {},
                dayDateData: {},
            }
        },
        mounted() {
            this._initRrcordScroll();
            this._totalReportScroll();
            this.getTotalInfo();
            this.getDayDateInfo();
            this.PickerAnchorDate();
            this.channel();
            this.pickerAnchor()
            this.getHospInfo()
            // 获取数据对比数据
            this.getDataContrast()
            this.getDataContrastPlan()
            // this.style = {'width': `${1.3 * 4}rem`}
            // console.log(1,this.style)
        },
        methods: {
            defPickerDate,
            defPickerAnchor,
            selectShow () {
                this.$refs.selectPicker.show()
            },
            recordPlan (e){
              this.$router.push("/record-plan");
            },
            // 切换医院
            handleSelectHospital (e) {
                this.cuuentHospital = e[0]['value']
                let hospId = this.picker['data'][e[0]['index']]['hos_id']
                this.picker['anchor'] = e
                this.$store.commit('changeHosp',{
                    hospId: hospId,
                    hospName: e[0]['value'],
                    hospIndex: e[0]['index']
                })
                this.getDataContrast()
                this.getDataContrastPlan()
            },
            pickerAnchor () {
                if(this.$store.state.hospIndex) {
                    this.picker.anchor = [
                        {
                            index: this.$store.state.hospIndex
                        }
                    ]
                }
            },
            // 获取医院列表
            getHospInfo () {
                axios.get('/phal/public/',{
                    params: {
                        s: 'App.Report.Sel_hospital',
                        sign: 1,
                        userid : this.$store.state.userInfo.userid
                    }
                }).then((res) => {
                    let result = res.data
                    let hospShow = ''
                    if (result.ret && result.ret === 200) {
                        let data = result.data
                        data.forEach((item) => {
                            item.value = item.hos_name
                            this.picker.data.push(item)
                            if(item.hos_id == this.$store.state.userInfo.hosid[0]) {
                                hospShow = item.hos_name
                            }
                        })
                        this.cuuentHospital = this.$store.state.hospName || hospShow || data[0]['hos_name']
                    }

                })
            },
            handleTopTabs(index, title) {
                if (title === "数据同比") {
                    this.isView = true;
                    this._dataTotalReportScroll()
                }else if(title === "任务制定"){
                    this.isView = true;
                    this._dataTotalReportScroll()
                }else {
                    this.isView = false;
                }
            },
            // 选择数据同比时间
            onChangeData (date) {
                if (date[0] && date[1]) {
                    this.dataSeleReport = [dayjs(date[0]).format('MM-DD'), dayjs(date[1]).format('MM-DD')]
                } else if (date[0]) {
                    this. dataSeleReport= [dayjs(date[0]).format('MM-DD')]
                }
            },
            // 选择数据报表时间
            onChange(date) {
                if (date[0] && date[1]) {
                    this.dataSele = [dayjs(date[0]).format('YYYY-MM-DD'), dayjs(date[1]).format('YYYY-MM-DD')]
                } else if (date[0]) {
                    this.dataSele= [dayjs(date[0]).format('YYYY-MM-DD')]
                }
            },
            // 数据报表取消操作
            dayClick(day) {
                console.log('day', dayjs(day).format('YYYY-MM-DD'))
                return true;
            },
            // 数据同比取消操作
            dataDayClick(day) {
                console.log('day', dayjs(day).format('YYYY-MM-DD'))
                return true;
            },
            cancleFail() {
                this.selectDatePicker = false
            },
            // 数据同比切换月份年份
            handelSwitchData (param) {
                if (parseInt(this.nowYear) !== parseInt(param.year)) {
                    this.$toast({
                        message: '不可选择非当前年',
                    })
                    return false
                }else {
                    this.switchDataReport = param
                }
            },
            // 数据视图切换月份年份
            handelSwitch(param) {
                this.switchData = param
            },
            // 月份选择显示影藏
            selectDateShow() {
                if (this.isView) {
                    this.switchDataReport = ''
                    this.dataSeleReport = []
                } else {
                    this.dataSele = []
                    this.switchData = ''
                }
                this.selectDatePicker = !this.selectDatePicker
            },
            // 月份选择显示影藏
            selectDateShowPlan() {
                if (this.isView) {
                    this.switchDataReport = ''
                    this.dataSeleReport = []
                } else {
                    this.dataSele = []
                    this.switchData = ''
                }
                this.selectDatePicker = !this.selectDatePicker
            },
            // 时间选择确定操作
            cancleOk() {
                if (this.isView) {
                    if (this.dataSeleReport.length === 2 ) {
                        this.getDataContrastPlan()
                        this.getDataContrast()
                        this.dataCurrentMonth = this.dataSeleReport[0] + '~' + this.dataSeleReport[1]
                        this.dataCurrentMonthPlan = this.dataSeleReport[0].match(/\d+/g)[0] + '月'
                    }  else if (this.dataSeleReport.length === 1) {
                        this.getDataContrast()
                        this.getDataContrastPlan()
                        this.dataCurrentMonth = this.dataSeleReport[0]
                        this.dataCurrentMonthPlan = this.dataSeleReport[0].match(/\d+/g)[0] + '月'
                    } else {
                        if (this.switchDataReport !== '') {
                            this.dataCurrentMonth = this.switchDataReport.month + '月'
                            this.dataCurrentMonthPlan = this.switchDataReport.month + '月'
                            this.getDataContrast()
                            this.getDataContrastPlan()
                        } else {
                            this.dataCurrentMonth = dayjs().format('MM') + '月'
                            this.dataCurrentMonthPlan = dayjs().format('MM') + '月'
                            this.getDataContrast()
                            this.getDataContrastPlan()
                        }
                    }
                } else {
                    if (this.dataSele.length === 2 ) {
                        this.getTotalInfo()
                        this.currentMonth = this.dataSele[0].slice(5, this.dataSele[0].length) + '~' + this.dataSele[1].slice(5, this.dataSele[0].length)
                    }  else if (this.dataSele.length === 1) {
                        this.getTotalInfo()
                        this.currentMonth = this.dataSele[0]
                    } else {
                        if (this.switchData !== '') {
                            this.currentMonth = this.switchData.year + '年' + this.switchData.month + '月'
                            this.getTotalInfo()
                        } else {
                            this.currentMonth = dayjs().format('YYYY') + '年' + dayjs().format('MM') + '月'
                            this.getTotalInfo()
                        }
                    }
                }

                this.selectDatePicker = false
            },
            //获取渠道数据
            channel() {
                axios
                    .get("/phal/public/", {
                        params: {
                            s: "App.Report.sel_all_qudao"
                        }
                    })
                    .then(res => {
                        let result = res.data;
                        if (result.ret && result.ret === 200) {
                            let data = result.data;
                            this.channelList = data;
                            this.canalPickerAnchor()
                        }
                    });
            },
            dataFormat (data, date) {
                return data.map((item, index) => {
                    return item[date[index]]
                })
            },
            costFormat (pic) {
                var temp = pic.map(function(item){
                    return (Number(item) / 10000).toFixed(2)
                })
                return temp;
            },
            ratioFormat (data) {
                var temp = data.map(function(item){
                    return Math.ceil(Number(item).toFixed(2) * 100)
                })
                return temp;
            },
            // 开始时间选择
            handleStartDate(e) {
                var year = e[0]["value"].replace(/[^\d]/g, "");
                var month = e[1]["value"].replace(/[^\d]/g, "");
                this.startDateValue = `${year}-${month}`;
            },
            // 按天选择
            selectDayShow() {
                this.$refs.selectDayPicker.show();
            },
            handleSelectDay(e) {
                //currentYear
                this.currentYear = e[0]['value']
                this.dayDate = e[1]["value"] + e[2]["value"];
                this.DayPicker.anchor = e;
                this.getDayDateInfo();
            },
            PickerAnchorDate() {
                let keep = getDay(-1, "-").split("-");
                this.DayPicker.anchor = [
                    { value: new Date().getFullYear() + "年" },
                    { value: keep[1].replace(/^0/,'') + "月" },
                    { value: keep[2] + "日" }
                ];
            },
            // 渠道筛选
            selectCanalShow() {
                this.$refs.selectPickerCanal.show();
            },
            // 每日渠道筛选
            daySelectCanalShow() {
                this.$refs.daySelectPickerCanal.show();
            },
            // 数据渠道筛选
            selectDataCanalShow() {
                this.$refs.selectDataPickerCanal.show();
            },
            canalPickerAnchor () {
                let addList = []
                let tmpList = []
                let allList = []
                let tailList = []
                let canalList = '';
                addList.push({
                    value: '全部',
                    index: '-1',
                    qudao: "全部",
                    qudao_id: "-1"
                })
                tailList.push({
                    value: '传统网络',
                    index: '100',
                    qudao: "传统网络",
                    qudao_id: "100"
                })
                tmpList.push(this.channelList)
                allList = [...addList,...tmpList[0],...tailList]
                allList.forEach((item) => {
                    item.value = item.qudao
                    item.index = item.qudao_id
                    this.pickerCanal.data.push(item)
                    this.dayPickerCanal.data.push(item)
                    this.pickerDataCanal.data.push(item)
                    canalList = item.qudao
                })
            },
            // 数据视图渠道筛选
            handleSelectCanal(e) {
                this.channelListId = e[0].index
                if(this.channelListId == 8) {
                    this.channelListId = '100'
                }
                this.getTotalInfo()
                this.canalName = e[0].value

            },
            dayHandleSelectCanal(e) {
                this.dayChannelListId = e[0].index
                if(this.dayChannelListId == 8) {
                    this.dayChannelListId = '100'
                }
                this.getDayDateInfo();
                this.dayCanalName = e[0].value

            },
            // 数据同比渠道筛选
            handleDataSelectCanal (e) {
                this.dataChannelListId = e[0].index
                if(this.dataChannelListId == 8) {
                    this.dataChannelListId = '100'
                }
                this.dataCanalName = e[0].value
                this.getDataContrast()
                this.getDataContrastPlan()
            },
            // 获取任务制定
            getDataContrastPlan () {
                let nowDate = new Date();
                let date = {
                    year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate(),
                }
                let s_time
                let e_time
                if (this.dataSeleReport.length === 2) {
                    s_time =  this.dataSeleReport[0]
                    e_time = this.dataSeleReport[1]
                } else if (this.dataSeleReport.length === 1) {
                    s_time =  this.dataSeleReport[0]
                    e_time = ''
                } else if (this.dataSeleReport.length === 0) {
                    if (this.switchDataReport !== '') {
                        s_time = this.switchDataReport.month
                        e_time = ''
                    } else {
                        s_time = this.dataCurrentMonth.match(/\d+/g)[0]+'-01'
                        e_time = this.dataCurrentMonth.match(/\d+/g)[0]+'-'+date.date
                    }
                }
                axios
                    .get("/phal/public/", {
                        params: {
                            s: "App.Report.sel_total_data_compare_plan",
                            hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
                            qudao_id: this.dataChannelListId,
                            s_time: s_time,
                            e_time: e_time
                        }
                    })
                    .then(res => {
                        let result = res.data;
                        if (result.ret && result.ret === 200) {
                            let data = result.data;
                            data.forEach(item => {
                                item.cost_price = (item.cost_price / 10000).toFixed(2);
                                item.in_base = Math.round(item.in_base);
                                item.sure_base = Math.round(item.sure_base)
                                if (!item.hasOwnProperty("dialog_cost")) {
                                    if (item.cost_price && item.dialog_count) {
                                        let temp = (item.cost_price * 10000) / item.dialog_count;
                                        if(temp == 'Infinity' || Number.isNaN(temp)) {
                                            item.dialog_cost = 0;
                                        }else {
                                            item.dialog_cost = Math.round(temp);
                                        }
                                    } else {
                                        item.dialog_cost = 0;
                                    }
                                }
                                if (!item.hasOwnProperty("conversion")) {
                                    if (item.in_count && item.dialog_count) {
                                        let temp = (item.in_count / item.dialog_count) * 100;
                                        if(temp == 'Infinity' || Number.isNaN(temp)) {
                                            item.conversion = 0;
                                        }else {
                                            item.conversion = temp.toFixed(2) + "%";
                                        }
                                    } else {
                                        item.conversion = 0;
                                    }
                                }
                            });
                            this.dataTotalContrastPlan = data;
                            this.style = {'width': `${2.3 * this.dataTotalContrastPlan.length}rem`}
                            console.log(2,this.style)
                        }
                    })
            },
            // 获取数据同比
            getDataContrast () {
                let nowDate = new Date();
                let date = {
                    year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate(),
                }
                let s_time
                let e_time
                if (this.dataSeleReport.length === 2) {
                    s_time =  this.dataSeleReport[0]
                    e_time = this.dataSeleReport[1]
                } else if (this.dataSeleReport.length === 1) {
                    s_time =  this.dataSeleReport[0]
                    e_time = ''
                } else if (this.dataSeleReport.length === 0) {
                    if (this.switchDataReport !== '') {
                        s_time = this.switchDataReport.month
                        e_time = ''
                    } else {
                        s_time = this.dataCurrentMonth.match(/\d+/g)[0]+'-01'
                        e_time = this.dataCurrentMonth.match(/\d+/g)[0]+'-'+date.date
                    }
                }
                axios
                    .get("/phal/public/", {
                        params: {
                            s: "App.Report.sel_total_data_compare",
                            hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
                            qudao_id: this.dataChannelListId,
                            s_time: s_time,
                            e_time: e_time
                        }
                    })
                    .then(res => {
                        let result = res.data;
                        if (result.ret && result.ret === 200) {
                            let data = result.data;
                            data.forEach(item => {
                                item.cost_price = (item.cost_price / 10000).toFixed(2);
                                item.in_base = Math.round(item.in_base);
                                item.sure_base = Math.round(item.sure_base)
                                if (!item.hasOwnProperty("dialog_cost")) {
                                    if (item.cost_price && item.dialog_count) {
                                        let temp = (item.cost_price * 10000) / item.dialog_count;
                                        if(temp == 'Infinity' || Number.isNaN(temp)) {
                                            item.dialog_cost = 0;
                                        }else {
                                            item.dialog_cost = Math.round(temp);
                                        }
                                    } else {
                                        item.dialog_cost = 0;
                                    }
                                }
                                if (!item.hasOwnProperty("conversion")) {
                                    if (item.in_count && item.dialog_count) {
                                        let temp = (item.in_count / item.dialog_count) * 100;
                                        if(temp == 'Infinity' || Number.isNaN(temp)) {
                                            item.conversion = 0;
                                        }else {
                                            item.conversion = temp.toFixed(2) + "%";
                                        }
                                    } else {
                                        item.conversion = 0;
                                    }
                                }
                            });
                            this.dataTotalContrast = data;
                            this.style = {'width': `${1.3 * this.dataTotalContrast.length}rem`}
                            console.log(2,this.style)
                        }
                    })
            },
            // 获取数据视图总报表
            getTotalInfo() {
                let s_time
                let e_time
                if (this.dataSele.length === 2) {
                    s_time =  this.dataSele[0]
                    e_time = this.dataSele[1]
                } else if (this.dataSele.length === 1) {
                    s_time =  this.dataSele[0]
                    e_time = ''
                } else if (this.dataSele.length === 0) {
                    if (this.switchData !== '') {
                        s_time =  this.switchData.year + '-' + this.switchData.month
                        e_time = ''
                    } else {
                        s_time = this.currentMonth.match(/\d+/g)[0] +"-" +this.currentMonth.match(/\d+/g)[1]
                        e_time = ''
                    }
                }
                axios
                    .get("/phal/public/", {
                        params: {
                            s: "App.Report.Sel_total_data",
                            userid: this.$store.state.userInfo.userid,
                            qudao_id: this.channelListId,
                            s_time: s_time,
                            e_time : e_time
                        }
                    })
                    .then(res => {
                        let result = res.data;
                        if (result.ret && result.ret === 200) {
                            let data = result.data;
                            data.forEach(item => {
                                item.cost_price = (item.cost_price / 10000).toFixed(2);
                                item.in_base = Math.round(item.in_base);
                                item.sure_base = Math.round(item.sure_base)
                                if (!item.hasOwnProperty("dialog_cost")) {
                                    if (item.cost_price && item.dialog_count) {
                                        let temp = (item.cost_price * 10000) / item.dialog_count;
                                        if(temp == 'Infinity' || Number.isNaN(temp)) {
                                            item.dialog_cost = 0;
                                        }else {
                                            item.dialog_cost = Math.round(temp);
                                        }
                                    } else {
                                        item.dialog_cost = 0;
                                    }
                                }
                                if (!item.hasOwnProperty("conversion")) {
                                    if (item.in_count && item.dialog_count) {
                                        let temp = (item.in_count / item.dialog_count) * 100;
                                        if(temp == 'Infinity' || Number.isNaN(temp)) {
                                            item.conversion = 0;
                                        }else {
                                            item.conversion = temp.toFixed(2) + "%";
                                        }
                                    } else {
                                        item.conversion = 0;
                                    }
                                }
                                if (!item.hasOwnProperty("progress")) {
                                    let temp = (item.in_count / item.total_in_count) * 100;
                                    if (temp == "Infinity" || Number.isNaN(temp)) {
                                        temp = 0;
                                    }else {
                                        item.progress = temp.toFixed(2) + "%";
                                    }
                                }
                            });
                            this.totalMonthData = data;
                        }
                    });
            },
            getDayDateInfo() {
                axios
                    .get("/phal/public/", {
                        params: {
                            s: "App.Report.Sel_day_data",
                            userid: this.$store.state.userInfo.userid,
                            qudao_id: this.dayChannelListId,
                            time:
                                +this.currentYear.toString().replace(/年/,'') +
                                "-" +
                                this.dayDate.replace(/月/, "-").replace(/日/, "")
                        }
                    })
                    .then(res => {
                        let result = res.data;
                        if (result.ret && result.ret === 200) {
                            let data = result.data;
                            data.forEach(item => {
                                item.cost_price = (item.cost_price / 10000).toFixed(2);
                                item.in_base = Math.round(item.in_base);
                            });
                            this.dayDateData = data;
                        }
                    });
            },
            _initRrcordScroll() {
                this.$nextTick(() => {
                    this.recordScroll = new BScroll(this.$refs.recordScroll, {
                        click: true,
                        swipeBounceTime: 100
                    });
                });
            },
            _totalReportScroll() {
                this.$nextTick(() => {
                    this.recordScroll = new BScroll(this.$refs.totalReport, {
                        scrollX: true,
                        click: true,
                        swipeBounceTime: 100
                    });
                });
            },
            _dataTotalReportScroll() {
                this.$nextTick(() => {
                    this.dataRecordScroll = new BScroll(this.$refs.dataTotalReport, {
                        scrollX: true,
                        click: true,
                        swipeBounceTime: 100
                    });
                });
            },
            fallback,
            dateParse(param, require) {
                let date = new Date(param * 1000);
                let m = date.getMonth() + 1;
                let d = date.getDate();
                if (require === "def") {
                    return m + "月" + d + "日";
                }
                if (require === "m") {
                    return m;
                }
                if (require === "d") {
                    return d;
                }
            }
        },
        components: {
            VFooter
        }
    };
</script>

<style lang="stylus" scoped>
    .record {
        .header {
            display: flex;
            justify-content: space-between;
            height: 1.1rem;
            padding: 0 0.2rem 0 0.4rem;
            background-color: #fff;

            .header-title {
                line-height: 1.1rem;
                color: #1d1d1d;
                font-size: 0.32rem;

                .plan-back {
                    display: inline-block;
                    width: 0.64rem;
                    font-size: 0.42rem;
                }

                .title {
                    font-size: 0.36rem;
                }
            }
        }

        >>>.van-tab {
            background-color: #f2f2f2;

            &.van-tab--active {
                color: #4DB3FF;
            }
        }

        .record-area {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 1.2rem;
            left: 0;
            z-index: 10;
            overflow: hidden;
            background-color: #f2f2f2;
        }
        .total-list {
            display: flex;
            padding: 0 .24rem;
            background-color: #ffffff;
            .item {
                flex: 1;
                text-align: center;
                padding-top: .3rem;
                font-weight: bold;
            }
        }
        .record-content {
            .report-show {
                margin-bottom: 0.24rem;
                padding: 0 0.2rem 0.4rem 0.4rem;
                background-color: #ffffff;

                .head {
                    padding-top: 0.24rem;
                    padding-bottom: 0.36rem;

                    &::after {
                        content: '';
                        display: block;
                        clear: both;
                    }

                    .title {
                        float: left;
                        height: 0.58rem;
                        line-height: 0.58rem;
                        margin-right: 0.24rem;
                    }

                    .select-date {
                        float: right;
                        font-size: 0;
                        margin-left: 0.2rem
                        .select {
                            box-sizing: border-box;
                            display: inline-block;
                            vertical-align: top;
                            width: 2rem;
                            height: 0.58rem;
                            line-height: 0.58rem;
                            font-size: 0.28rem;
                            text-align: center;
                            border: 1px solid #666666;
                            border-right: none;
                        }
                        .icon-wrapper {
                            box-sizing: border-box;
                            display: inline-block;
                            vertical-align: top;
                            width: 0.48rem;
                            height: 0.58rem;
                            line-height: 0.58rem;
                            text-align: center;
                            border: 1px solid #666666;

                            .select-icon {
                                font-size: 0.28rem;
                            }
                        }
                    }

                    .select-day {
                        float: right;
                        height: 0.58rem;
                        line-height: 0.58rem;
                        font-size: 0;
                        color: #0099ff;

                        .icon-wrapper {
                            display: inline-block;
                            vertical-align: top;

                            .iconfont {
                                font-size: 0.48rem;
                            }
                        }

                        .select {
                            display: inline-block;
                            width: 1.5rem;
                            margin-left: 0.12rem;
                            font-size: 0.32rem;
                            text-align: center;
                        }
                    }
                }

                .table-wrapper {
                    font-size: 0;

                    .hosp-name {
                        display: inline-block;
                        vertical-align: top;
                        width: 0.8rem;
                        font-size: 0.28rem;
                        color: #666666;

                        .tr {
                            box-sizing: border-box;
                            height: 0.72rem;
                            line-height: 0.72rem;
                            font-size: 0.26rem;
                            text-align: center;
                            border-right: 1px solid #666666;

                            span {
                                display: block;
                            }

                            &+.tr {
                                border-top: 1px solid #666666;
                            }
                        }
                    }

                    .table-content {
                        display: inline-block;
                        vertical-align: top;
                        width: 100%;
                        overflow: hidden;

                        &.active {
                            width: 6rem;
                        }

                        .total-table {
                            width: (1.8rem * 9)
                            color: #666666;

                            &.day-date-table {
                                width: 16.2rem;
                            }

                            .thead {
                                .tr {
                                    .th {
                                        display: inline-block;
                                        width: 1.8rem;
                                        height: 0.72rem;
                                        line-height: 0.72rem;
                                        font-size: 0.26rem;
                                        text-align: center;
                                    }
                                }
                            }

                            .tbody {
                                .tr {
                                    box-sizing: border-box;
                                    height: 0.72rem;
                                    line-height: 0.72rem;
                                    border-top: 1px solid #666666;

                                    .td {
                                        display: inline-block;
                                        width: 1.8rem;
                                        font-size: 0.26rem;
                                        text-align: center;
                                    }
                                }
                            }
                        }
                    }
                }

                .table-day-wrapper {
                    .table-content {
                        .total-table {
                            &.day-date-table {
                                width: 100%;
                            }

                            .thead {
                                .tr {
                                    .th {
                                        width: 25%;
                                    }
                                }
                            }

                            .tbody {
                                .tr {
                                    .td {
                                        width: 25%;
                                    }
                                }
                            }
                        }
                    }
                }
                .table-total-wrapper {
                    .table-content {
                        .total-table {
                            width: (1.8rem * 9)
                            color: #666666;
                            .thead {
                                .tr {
                                    .th:nth-child(1) ,.th:nth-child(2),.th:nth-child(4),
                                    .th:nth-child(3),.th:nth-child(5) {
                                        width: 1.4rem;
                                    }
                                }
                            }
                            .tbody {
                                .tr {
                                    .td:nth-child(1), .td:nth-child(2),.td:nth-child(4)
                                    ,.td:nth-child(3),.td:nth-child(5) {
                                        width: 1.4rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .view-report {
            min-height 500px
            background-color: #ffffff
            padding: 0 .2rem 0 .4rem
            .table-wrapper {
                font-size: 0;
                .hosp-name {
                    display: inline-block;
                    vertical-align: top;
                    width: 0.8rem;
                    font-size: 0.28rem;
                    color: #666666;

                    .tr {
                        box-sizing: border-box;
                        height: 0.72rem;
                        line-height: 0.72rem;
                        font-size: 0.26rem;
                        text-align: center;
                        border-right: 1px solid #666666;

                        span {
                            display: block;
                        }

                        &+.tr {
                            border-top: 1px solid #666666;
                        }
                    }
                }
                .hosp-names{
                    width:1.8rem;
                    .tr{
                        text-align: right;
                        padding-right: .1rem;
                    }
                }

                .table-content {
                    display: inline-block;
                    vertical-align: top;
                    width: 100%;
                    overflow: hidden;

                    &.active {
                        width: 6rem;
                    }

                    .total-table {
                        width: (1.8rem * 8)
                        color: #666666;

                        &.day-date-table {
                            width: 16.2rem;
                        }

                        .thead {
                            .tr {
                                .th {
                                    display: inline-block;
                                    width: 1.8rem;
                                    height: 0.72rem;
                                    line-height: 0.72rem;
                                    font-size: 0.26rem;
                                    text-align: center;
                                }
                            }
                        }

                        .tbody {
                            .tr {
                                box-sizing: border-box;
                                height: 0.72rem;
                                line-height: 0.72rem;
                                border-top: 1px solid #666666;
                                border-left: 1px solid grey;

                                .td {
                                    display: inline-block;
                                    width: 1.8rem;
                                    font-size: 0.26rem;
                                    text-align: center;
                                }
                            }
                        }
                        .tbody2 {
                            .tr {
                                box-sizing: border-box;
                                height: 0.72rem;
                                line-height: 0.72rem;
                                border-top: 1px solid #666666;
                                border-left: 1px solid grey;

                                .td {
                                    display: inline-block;
                                    width: 1.8rem;
                                    font-size: 0.26rem;
                                    text-align: left;
                                    margin-left: 5px;
                                }
                            }
                        }
                    }
                }
                .table-contents{
                    width: 5rem!important;
                    .tbody{
                        display: flex;
                        .trs{
                            border-top:none!important;
                        }
                        .td{
                            width:1.3rem!important;
                        }
                    }
                }
                .table-contents2{
                    width: 5rem!important;
                    .tbody{
                        display: flex;
                        .trs{
                            border-top:none!important;
                        }
                        .td{
                            width:2rem!important;
                        }
                    }
                }
            }

            .table-total-wrapper {
                .table-content {
                    .total-table {
                        width: (1.8rem * 8)
                        color: #666666;
                        .thead {
                            .tr {
                                .th:nth-child(1) ,.th:nth-child(2),.th:nth-child(4),
                                .th:nth-child(3),.th:nth-child(5) {
                                    width: 1.8rem;
                                }
                            }
                        }
                        .tbody {
                            .tr {
                                .td:nth-child(1), .td:nth-child(2),.td:nth-child(4)
                                ,.td:nth-child(3),.td:nth-child(5) {
                                    width: 1.8rem;
                                }
                            }
                        }
                    }
                }
            }
            .header-select {
                margin-bottom 20px
                .select-date {
                    display inline-block
                    margin-left .3rem
                }
                .select-wrapper {
                    display: inline-block
                    font-size: 0
                    .select {
                        box-sizing: border-box
                        display: inline-block
                        vertical-align: top
                        width: 1.48rem
                        height: .58rem
                        line-height: .58rem
                        font-size: .28rem
                        text-align: center
                        border: 1px solid #666666
                        border-right: none
                    }
                    .select:last-child {
                        width: 1.88rem
                    }
                    .icon-wrapper {
                        box-sizing: border-box
                        display: inline-block
                        vertical-align: top
                        width: .48rem
                        height: .58rem
                        line-height: .58rem
                        text-align: center
                        border: 1px solid #666666
                    }
                        .select-icon {
                            font-size: .28rem
                        }
                }
            }
        }
        .mask {
            position : absolute;
            left: 0;
            bottom 60px;
            width:100%
            height: 100%
            background-color : rgba(0, 0, 0, 0.4);
            z-index: 999;
            .mask-data {
                position : fixed
                width:100%
                bottom 60px;
                .action-style{
                    widows: 100%;
                    height:40px;
                    line-height 40px
                    display flex
                    background-color : #ffffff
                    span {
                        flex : 1
                        text-align center
                    }
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/record/Record.vue